<template lang="pug">
    v-img.shrink.hover-img(
        alt="Pulse Icon"
        contain
        src="https://volie-assets.s3.us-east-1.amazonaws.com/system/pulse_branding/PulsePrimaryLogo_Light_Icon.png"
        :width="size"
    )

</template>

<!-- No tm on this asset -->

<script lang="ts">
    import Vue from 'vue';

    export default Vue.extend({
        data() {
            return {}
        },
        computed: {},
        props: {
            size: {
                type: Number,
                default: 62,
            },
        },
    });
</script>

<style lang="scss" scoped>
    .hover-img::v-deep(.v-image__image) {
        transition: opacity 0.2s ease, transform 0.2s ease;
    }

    .hover-img:hover::v-deep(.v-image__image) {
        opacity: 0.7;
        transform: scale(1.05);
    }

// filter: opacity(46%) grayscale(34%) hue-rotate(192deg); // to alter image color
</style>
